import { ElementObj } from '../../../../viewer/elements/element-obj';
import { SubscriptionTopic } from '../../../../viewer/messaging/pubsub';
import { useNonce } from '../../../hooks/use-nonce';
import { useSubscribe } from '../../../hooks/use-subscribe';

export function useAssetChangedEvent(asset?: ElementObj) {
  const [assetChangedEvent, invokeAssetChangedEvent] = useNonce();
  useSubscribe(SubscriptionTopic.AssetChanged, (x) => {
    if (x.uuid === asset?.uuid) {
      invokeAssetChangedEvent();
    }
  });

  useSubscribe(SubscriptionTopic.SkyviewAssetVisibilityChanged, (message) => {
    if (message?.assetUuid === asset?.uuid) {
      invokeAssetChangedEvent();
    }
  });

  return { assetChangedEvent };
}
